import { useNavigate, useRouterState, useSearch } from '@tanstack/react-router'
import { useCallback, useMemo } from 'react'

export const useRegisterApplicant = () => {
  const routerState = useRouterState()
  const navigate = useNavigate()
  const search = useSearch({ strict: false })
  const { registerApplicant } = search

  const isDialogOpen = useMemo(() => typeof registerApplicant === 'boolean' && registerApplicant, [registerApplicant])

  const openDialog = useCallback(async () => {
    await navigate({
      to: routerState.location.pathname,
      search: {
        ...routerState.location.search,
        registerApplicant: true,
      },
    })
  }, [navigate, routerState.location.pathname, routerState.location.search])

  const closeDialog = useCallback(async () => {
    const newSearch: Record<string, unknown> = {
      ...routerState.location.search,
    }
    delete newSearch.registerApplicant

    await navigate({
      to: routerState.location.pathname,
      search: newSearch,
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routerState.location.search, routerState.location.pathname])

  return {
    isDialogOpen,
    openDialog,
    closeDialog,
  }
}
